import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AuditFormView from '@/views/AuditFormView.vue'
import EnterpriseRAGView from '@/views/EnterpriseRAGView.vue'
import PrivacyView from '@/views/PrivacyView.vue'
import ShareSecretView from '@/views/ShareSecretView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/audit-request',
    name: 'audit-request',
    component: AuditFormView
  },
  {
    path: '/enterprise-rag-book',
    name: 'enterprise-rag-book',
    component: EnterpriseRAGView
  },
  {
    path: '/share',
    name: 'share',
    component: ShareSecretView,
    alias: '/secret'
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  }
})

export default router
